import { render } from "./FinishChatEditorCmp.vue?vue&type=template&id=3158f8b4"
import script from "./FinishChatEditorCmp.vue?vue&type=script&lang=js"
export * from "./FinishChatEditorCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__